import React from "react";
import { GraduationCap, Building2, Bone, Activity, Footprints } from "lucide-react";
import { timeline } from "../mock";
import Reveal from "./Reveal";
import { useReveal } from "../hooks/useReveal";

const iconMap = { GraduationCap, Building2, Bone, Activity, Footprints };

const Timeline = () => {
  const [lineRef, lineIn] = useReveal({ threshold: 0.05 });
  return (
    <section id="timeline" className="bg-white">
      <div className="max-w-4xl mx-auto px-4 py-20">
        <Reveal className="text-center mb-16">
          <span className="text-xs font-bold tracking-[0.3em] uppercase text-gold">The Path</span>
          <h2 className="font-head text-3xl sm:text-4xl uppercase tracking-wide text-navy mt-2">Education & Training</h2>
          <div className="w-16 h-0.5 bg-gold mx-auto mt-4" />
        </Reveal>

        <div ref={lineRef} className="relative pl-2">
          {/* vertical line */}
          <div className="absolute left-[27px] sm:left-1/2 top-2 bottom-2 w-0.5 bg-gray-200">
            <div className={`tl-line${lineIn ? " in-view" : ""} w-full h-full bg-gold`} />
          </div>

          <div className="space-y-10">
            {timeline.map((t, i) => {
              const Icon = iconMap[t.icon];
              const left = i % 2 === 0;
              return (
                <Reveal key={i} delay={1} className="relative">
                  <div className={`flex items-start gap-6 sm:gap-0 ${left ? "sm:flex-row" : "sm:flex-row-reverse"}`}>
                    {/* node */}
                    <div className="absolute left-0 sm:left-1/2 sm:-translate-x-1/2 z-10">
                      <div className="w-14 h-14 rounded-full bg-navy border-4 border-white ring-2 ring-gold flex items-center justify-center shadow-lg">
                        <Icon className="w-6 h-6 text-gold" />
                      </div>
                    </div>
                    {/* card */}
                    <div className={`ml-20 sm:ml-0 sm:w-[calc(50%-3rem)] ${left ? "sm:mr-auto sm:text-right sm:pr-12" : "sm:ml-auto sm:text-left sm:pl-12"}`}>
                      <div className="bg-cream rounded-xl border border-black/5 p-6 hover:shadow-md transition-shadow">
                        <span className="inline-block text-[11px] font-bold tracking-widest uppercase text-gold mb-1">{t.period}</span>
                        <h3 className="font-head text-xl uppercase tracking-wide text-navy">{t.title}</h3>
                        <p className="text-sm text-gray-600 mt-1">{t.place}</p>
                      </div>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Timeline;
